export default {
  manifestTemplates: 'https://feeport.atlassian.net/servicedesk/customer/portal/1/article/30769156#Manifest-templates',
  supportCenter: 'https://feeport.atlassian.net/servicedesk/customer/portals',
}
